import React, { createContext, useState, useContext } from 'react';

// Declare global state in React using context
const GlobalStateContext = createContext();

export const useGlobalState = () => useContext(GlobalStateContext);

export const GlobalStateProvider = ({ children }) => {
    const [shopId, setShopId] = useState(null); // Store shopId in context state

    // Set global shop ID and context state
    const updateShopId = (id) => {
        setShopId(id);  // Update context state
    };

    return (
        <GlobalStateContext.Provider value={{ shopId, setShopId: updateShopId }}>
            {children}
        </GlobalStateContext.Provider>
    );
};
